import { PolicyModalView } from '@services/Marpple/client/widgets/CreatorDesign/PolicyModalView.page.ts';
import { MuiF } from '../../../../../Mui/F/Function/module/MuiF.js';
import { OMPCoreUtilF } from '../../../../../OMP/Core/Util/F/Function/module/OMPCoreUtilF.js';
import { SimpleModalMuiF } from '../../../../../SimpleModal/F/Mui/module/SimpleModalMuiF.js';

export const openFrame = (src) => {
  return new Promise((resolve) => {
    MuiF.openFrame(SimpleModalMuiF.frame, async (f, p, [t]) => {
      t.template = async () => {
        return new PolicyModalView().toHtmlSSR();
      };
      t.appended = (el) => {
        OMPCoreUtilF.hydrationRune(PolicyModalView);
      };
    });
  });
};
